import type { BankStatement } from '@api/models';
import { BankStatementQueryParams } from '@api/query';
import type { ComputedRef } from 'vue';

import { stuut } from '@/api';

import { computeEffectiveParams, useResourceNavigation } from './useResourceNavigation';
import type { UseResourceNavigationReturn } from './useResourceNavigation';

export interface UseBankStatementNavigationOptions {
  params?: ComputedRef<BankStatementQueryParams | null>;
}

export function useBankStatementNavigation(
  statementId: ComputedRef<string>,
  options: UseBankStatementNavigationOptions = {},
): UseResourceNavigationReturn {
  const effectiveParams = computeEffectiveParams<BankStatementQueryParams>(
    options.params,
    BankStatementQueryParams,
    {
      sortBy: 'period_start',
      sortOrder: 'desc',
    },
  );

  return useResourceNavigation<BankStatement, BankStatementQueryParams>(statementId, {
    fetchList: (params) => stuut.bankStatements.list({ params }, true),
    detailRouteName: 'cash-app.bank-statements.statement',
    params: effectiveParams,
    queryKeyPrefix: 'bank-statements',
    paramsClass: BankStatementQueryParams,
  });
}
